module.exports = __webpack_public_path__ + "static/media/uploadedFile.facaf969.svg";